import React from 'react';
import '../css/PaginaAdmTecnico.css';
import { FaUserPlus, FaTools } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

function PaginaAdmTecnico() {

    const navigate = useNavigate();

    const handleLogout = () => {
        Cookies.remove('dadosCookies');
        navigate('/conta');
    };

  return (
    <div className="pagina-adm-tecnico">
      <h1>Painel do Administrador Técnico</h1>

      <div className="opcoes-container">

        <Link to="/cadastrar-representante-comercial" className="opcao-box">
          <FaUserPlus size={50} style={{ marginBottom: '10px' }} />
          <span>Cadastrar Representante Comercial</span>
        </Link>

        <Link to="/cadastrar-tipo-servico" className="opcao-box">
          <FaTools size={50} style={{ marginBottom: '10px' }} />
          <span>Cadastrar Tipos de Serviços</span>
        </Link>

        <Link to="/visualizar-todos-os-pontos-no-mapa" className="opcao-box">
          <FaUserPlus size={50} style={{ marginBottom: '10px' }} />
          <span>Visualizar pontos no mapa</span>
        </Link>



      </div>

        <button onClick={handleLogout} className="btn btn-danger logout-btn">
            Sair
        </button>


    </div>
  );
}

export default PaginaAdmTecnico;
